module.exports = __webpack_public_path__ + "static/media/bookmark-filled.8811d402.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/bookmark-filled.svg
// module id = 2350
// module chunks = 0